import { Directive, ElementRef, inject, Input, OnInit, Renderer2 } from '@angular/core';

export type PDSSkeletonColor = 'default' | 'primary' | 'secondary' | 'terciary';

@Directive({
  selector: '[pdsSkeleton]',
  standalone: false,
})
export class PDSSkeletonDirective implements OnInit {
  @Input() width = '100%';
  @Input() height = '100%';
  @Input() color: PDSSkeletonColor = 'default';
  @Input() borderRadius = '4px';

  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  get hostElement() {
    return this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.renderer.addClass(this.hostElement, 'pds-skeleton');
    this.renderer.addClass(this.hostElement, `pds-color-${this.color}`);
    this.renderer.setStyle(this.hostElement, 'width', this.width);
    this.renderer.setStyle(this.hostElement, 'height', this.height);
    this.renderer.setStyle(this.hostElement, 'border-radius', this.borderRadius);
  }
}
